module.exports = __webpack_public_path__ + "img/77.fec4505a.jpg";